import React, { createContext, useState } from 'react'
const defaultState = {
  isLoading: false,
  isContentLoaded: false,
  isInitialLoading: true
}
export const LoadingContext = createContext(defaultState)

const LoaderContextProvider = props => {
  const [isLoading, setLoading] = useState(true)
  const [isInitialLoading, setInitialLoading] = useState(true)
  const [isContentLoaded, setContentLoaded] = useState(true)

  return (
    <LoadingContext.Provider value={{
      loading: [isLoading, setLoading],
      initLoading: [isInitialLoading, setInitialLoading],
      contentLoaded: [isContentLoaded, setContentLoaded]
    }}>
      {props.children}
    </LoadingContext.Provider>
  )
}

export default LoaderContextProvider